import React, { useId } from 'react';
import cx from 'classnames';

import { BrItem } from './BrItem';

export const DocumentsCollapse = ({
  secondary = [],
  curriculumFile,
  messages,
  intl,
  className,
  isEditMode = false,
}) => {
  const listId = useId();

  if (!secondary.length && !curriculumFile) return null;
  return (
    <details className={cx('person-card__links-collapse my-base', className)}>
      <summary
        className="text-base text-weight-medium px-2x d-inline-flex align-items-center gap-1"
        aria-controls={listId}
      >
        <span
          className="fa-solid fa-angle-down collapse-icon"
          aria-hidden="true"
        />
        {intl.formatMessage(messages.documentsTitle)}
      </summary>
      <div className="mt-base person-card__docs-list" id={listId}>
        {secondary.map((item) => (
          <BrItem
            key={`${item.source}-${item.href}`}
            icon={item.icon || 'fa-solid fa-file'}
            href={item.href}
            openLinkInNewTab
            className="text-interactive"
            isEditMode={isEditMode}
          >
            {item.label}
          </BrItem>
        ))}
        {curriculumFile && (
          <BrItem
            icon="fa-regular fa-id-badge"
            href={curriculumFile.download}
            openLinkInNewTab
            className="text-interactive"
            isEditMode={isEditMode}
          >
            {intl.formatMessage(messages.curriculumView)}
          </BrItem>
        )}
      </div>
    </details>
  );
};
